// extracted by mini-css-extract-plugin
module.exports = {"imgWrapper":"InstagramFeedCard_imgWrapper__Icp-6","heartOverly":"InstagramFeedCard_heartOverly__1jIru"};